exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".selected-date-in-button\n{\n  color: #28a645;\n  font-size: 0.9em;\n  margin: 5px;\n  text-align: center;\n  direction: rtl;\n  /*height: 40px;*/\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/select-date-dialog/select-date-dialog.style.css
// module id = 992
// module chunks = 3